

export default function formatE164( phone, country ) {
  const
    france = /^(?:0[1-9])/,
    spain = /^[6|7|8|9]/,
    portugal = /^[2|9]/,
    italy = /^((0{1}[1-9]{1})|(38[890]|34[7-90]|36[680]|33[3-90]|32[89]))/,
    uk = /^0{1}[1|2|3|5|7]/,
    belgium = /^(?:0[1-9])/,
    mexico = /^[1-9]/,
    ireland = /^(?:0[1-9])/,
    japan = /^(?:0[1-9])/,
    brazil = /^[2-9]/,
    austria = /^(?:0[1-9])/,
    international = /^(?:00)/,
    value = phone.replace( /\s/g, '' );

  switch ( true ) {
  case country === 'FR' && france.test( value ):
    return value.replace( /^(?:0)/, '+33' );
  case country === 'ES' && spain.test( value ):
    return `+34${ value }`;
  case country === 'PT' && portugal.test( value ):
    return `+351${ value }`;
  case country === 'IT' && italy.test( value ):
    return `+39${ value }`;
  case country === 'GB' && uk.test( value ):
    return `+44${ value }`;
  case country === 'BE' && belgium.test( value ):
    return value.replace( /^(?:0)/, '+32' );
  case country === 'MX' && mexico.test( value ):
    return `+52${ value }`;
  case country === 'IE' && ireland.test( value ):
    return value.replace( /^(?:0)/, '+353' );
  case country === 'JP' && japan.test( value ):
    return value.replace( /^(?:0)/, '+81' );
  case country === 'BR' && brazil.test( value ):
    return `+55${ value }`;
  case country === 'AT' && austria.test( value ):
    return `+43${ value }`;
  case international.test( value ):
    return value.replace( international, '+' );
  default:
    return value;
  }
}
